module.exports = __webpack_public_path__ + "static/img/swipe_mask.f21e341.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/Zuzuche/swipe_mask.png
// module id = UdKU
// module chunks = 19